import { createContext } from "react";
import type { ConfigProviderProps, Config as IConfig } from "./types";
import Config from "./Config";

export const ConfigContext = createContext<IConfig>(new Config());

const ConfigProvider = (props: ConfigProviderProps) => (
    <ConfigContext.Provider
        {...props}
    />
);

export default ConfigProvider;
